import styled from '@themes/theme'

export const TimelineTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  
  .timeline {
    &--image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 21px;
      height: 21px;
      overflow: hidden;
      img {
        width: 17px;
        height: 17px;
        object-fit: cover;
      }
      &--wrap {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 2px;
      }
    }
    &--text {
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.regular};
      color: ${props => props.theme.color.darkTxt};
    }
  }
  
`
